import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.admin.audit').factory('AuditSvc', AuditSvc);

    AuditSvc.$inject = ['AuditDA'];

    /* @ngInject */
    function AuditSvc(AuditDA) {
        var exports = {
            searchAudit: searchAudit,
            getActions: getActions,
        };

        return exports;

        function searchAudit(searchData) {
            return AuditDA.searchAudit(searchData);
        }

        function getActions() {
            return AuditDA.getActions();
        }
    }
})();
